import { render, staticRenderFns } from "./day_total.vue?vue&type=template&id=1b774842&"
import script from "./day_total.vue?vue&type=script&lang=js&"
export * from "./day_total.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports